import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Grid,
    Segment
} from 'semantic-ui-react'
import './style.css'
import ExternalPaymentsData from '../../mock/CreditCard/externalPaymentsData'
import { useConfirmPopup } from '../../hooks/useConfirmPopup'
import { useMessageResources, useTextResources } from '../../language'
import { onSuccess } from '../shared/messages'


const ExternalPayments = ({ onSelect, onSelectItem }) => {
    const { confirm } = useConfirmPopup();
    const text = useTextResources();
    const message = useMessageResources();
    const [availableProviders, setAvailableProviders] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState();

    //TODO: get from server
    useEffect(() => {
        setAvailableProviders([25]);
    }, [])

    const selectExternalPayment = function (externalPayment) {
        setSelectedPayment(externalPayment);
        if (onSelect)
            onSelect(externalPayment.name);
        if (onSelectItem)
            onSelectItem(externalPayment);
    }

    const getClassName = function (externalPayment) {
        if (selectedPayment && selectedPayment.id == externalPayment.id)
            return 'external-payment-segment external-payment-segment-selected';
        else
            return 'external-payment-segment'
    }

    const resetZCredit = () => {
        confirm({
            // header: text('AreYouSure'),
            content: message('ConfirmDeletePinPadCode'),
            confirmButton: {
                content: text('Yes'),
                positive: true,
            },
            cancelButton: {
                content: text('No'),
                negative: true,
            },
            onConfirm: () => { 
                window.localStorage.removeItem("pinpadCode_25_ZCredit");
                onSuccess();
            },
        });
    }

    return <div>
        <Grid columns={3} doubling>
            {
                ExternalPaymentsData.filter(x => availableProviders.includes(x.id)).map(externalPayment => {
                    return (
                        <Grid.Column key={externalPayment.id}>
                            <Segment className={getClassName(externalPayment)} onClick={() => selectExternalPayment(externalPayment)} >
                            <Button
                                icon="trash"
                                circular
                                size="mini"
                                color="red"
                                inverted
                                className='reset-z-credit'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    resetZCredit();
                                }}
                            ></Button>
                                <img src={`data:image/jpeg;base64,${externalPayment.image}`} alt={externalPayment.name} />
                            </Segment>
                        </Grid.Column>
                    )
                })
            }
        </Grid>
    </div>
}

ExternalPayments.propTypes = {
    onSelect: PropTypes.func,
    onSelectItem: PropTypes.func
}

export default ExternalPayments